import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostLoadDirective } from './postload.directive';



@NgModule({
    declarations: [
        PostLoadDirective
    ],
    exports: [
        PostLoadDirective,
    ],
    imports: [
        CommonModule
    ]
})
export class CbPostLoadModule { }
